import { createSlice } from "@reduxjs/toolkit"
import {
  addCategory,
  deleteCategory,
  getAllCategoriesList,
  getCategories,
  getCategoryDetails,
  updateCategoryDetails,
  updateCategoryStatus,
} from "store/actions/categoriesAction"

const initialState = {
  loading: true,
  error: null,
  isLoading: false,
  actionType: null,
  message: null,
  itemsPerPage: 12,
  totalCount: null,
  totalPages: null,
  currentPage: 1,
  isUpdating: false,
  categoriesLists: [],
  categoryDetails: {},
  allCategories: [], // only list of categories
}

const usersSlice = createSlice({
  name: "categories", //
  initialState,
  reducers: {},
  extraReducers: builder => {
    // FETCH ALL CATEGORIES
    builder
      .addCase(getAllCategoriesList.pending, state => {
        state.loading = true
        state.error = null
        state.actionType = null
        state.categoriesLists = []
      })
      .addCase(getAllCategoriesList.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          const { totalCount, totalPages, currentPage } = action.payload
          state.categoriesLists = data
          state.totalCount = totalCount
          state.totalPages = totalPages
          state.currentPage = currentPage
        }
      })
      .addCase(getAllCategoriesList.rejected, (state, action) => {
        state.loading = false
      })

    // ALL CATEGORIES LIST
    builder
      .addCase(getCategories.pending, state => {
        state.error = null
        state.actionType = null
        state.allCategories = []
      })
      .addCase(getCategories.fulfilled, (state, action) => {
        const { status, data } = action.payload
        if (status) {
          state.allCategories = data
        }
      })
      .addCase(getCategories.rejected, (state, action) => {})

    // UPDATE CATEGORIES STATUS
    builder
      .addCase(updateCategoryStatus.pending, state => {
        state.error = null
        state.actionType = null
        state.isUpdating = true
      })
      .addCase(updateCategoryStatus.fulfilled, (state, action) => {
        state.isUpdating = false
        const { status } = action.payload
        if (status) {
          const { id, status } = action.meta.arg
          //
          state.categoriesLists = state.categoriesLists.map(item =>
            item._id === id ? { ...item, status: Number(status) } : item
          )
          state.message = action.payload.msg
          state.actionType = "CATEGORY_STATUS_UPDATE_SUCCESS"
        } else {
          state.actionType = "CATEGORY_STATUS_UPDATE_FAILED"
          state.error = action.payload.msg
        }
      })
      .addCase(updateCategoryStatus.rejected, (state, action) => {
        state.isUpdating = false
      })
    // DELETE CATEGORY
    builder
      .addCase(deleteCategory.pending, state => {
        state.error = null
        state.isLoading = true
        state.actionType = null
      })
      .addCase(deleteCategory.fulfilled, (state, action) => {
        const { status, msg } = action.payload
        const { id, setShowDeleteModal } = action.meta.arg
        state.isLoading = false
        if (status) {
          state.categoriesLists = state.categoriesLists.filter(
            item => item._id !== id
          ) //
          state.error = null
          state.actionType = "CATEGORY_DELETE_SUCCESS" //
          state.message = msg
          setShowDeleteModal(false)
          // Decrement the totalCount if it exists
          if (state.totalCount !== null) {
            state.totalCount -= 1
          }
        } else {
          state.actionType = "CATEGORY_DELETE_FAILED" //
          state.error = msg
        }
      })
      .addCase(deleteCategory.rejected, (state, action) => {
        state.isLoading = false
      })

    //ADD CATEGORY
    builder
      .addCase(addCategory.pending, state => {
        state.error = null
        state.isLoading = true
        state.actionType = null
        state.message = null
      })
      .addCase(addCategory.fulfilled, (state, action) => {
        state.isLoading = false
        const { status } = action.payload
        if (status) {
          state.actionType = "CATEGORY_ADDED_SUCCESS"
          state.message = action.payload.msg
          // action.meta.arg.navigate("") //
        } else {
          state.error = action.payload.msg
          state.actionType = "CATEGORY_ADDED_FAILED"
        }
      })
      .addCase(addCategory.rejected, (state, action) => {
        state.isLoading = false
      })

    // GET CATEGORY DETAILS
    builder
      .addCase(getCategoryDetails.pending, state => {
        state.loading = true
        state.error = null
        state.actionType = null
      })
      .addCase(getCategoryDetails.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          state.categoryDetails = data
        }
      })
      .addCase(getCategoryDetails.rejected, (state, action) => {
        state.loading = false
      })

    // UPDATE CATEGORY DETAILS
    builder
      .addCase(updateCategoryDetails.pending, state => {
        state.error = null
        state.isLoading = true
        state.actionType = null
        state.message = null
      })
      .addCase(updateCategoryDetails.fulfilled, (state, action) => {
        state.isLoading = false
        const { status } = action.payload
        if (status) {
          state.actionType = "UPDATED_CATEGORY_DETAILS_SUCCESS"
          state.message = action.payload.msg
        } else {
          state.actionType = "UPDATED_CATEGORY_DETAILS_FAILED" //
          state.error = action.payload.msg
        }
      })
      .addCase(updateCategoryDetails.rejected, (state, action) => {
        state.isLoading = false
      })
  },
})

export default usersSlice.reducer
